import { uploadOther,postP } from '@/utils/axios'

export default {
   
    uploadOther(file,params){
        return uploadOther('',file,params)
    },

    MAddDoubtTaskItemDoubTaskMaterial(params){
        return postP('DoubtTaskItem/MAddDoubtTaskItemDoubTaskMaterial',params)
    },
    
}